import React from "react";
import { X, Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatINR } from "@/components/site/ProductCard";

const CartDrawer = () => {
  const { items, subtotal, drawerOpen, setDrawerOpen, updateQty, removeItem } =
    useCart();

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-50 transition-opacity duration-300 ${
          drawerOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setDrawerOpen(false)}
      />
      <aside
        className={`fixed top-0 right-0 h-full w-full sm:w-[460px] bg-[#0b0b0c] border-l border-[#1c1c1e] z-50 transform transition-transform duration-300 ease-out ${
          drawerOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-[#1c1c1e]">
          <div className="font-serif text-[#f4ead5] text-xl">Your Bag</div>
          <button
            onClick={() => setDrawerOpen(false)}
            className="text-[#e9d9b0] hover:text-[#c9a24a] transition-colors"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        <div className="h-[calc(100%-190px)] overflow-y-auto px-6 py-5 space-y-5">
          {items.length === 0 ? (
            <div className="text-center py-16">
              <div className="text-[#a9a294] text-sm">Your bag is empty.</div>
              <button
                onClick={() => setDrawerOpen(false)}
                className="mt-6 text-[#c9a24a] uppercase text-xs tracking-[0.3em] hover:underline"
              >
                Continue shopping
              </button>
            </div>
          ) : (
            items.map((it) => (
              <div key={it.slug} className="flex gap-4">
                <div className="w-20 h-24 flex-shrink-0 bg-[#111112] overflow-hidden">
                  <img src={it.image} alt={it.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#c9a24a]">
                    {it.category}
                  </div>
                  <div className="font-serif text-[#f4ead5] text-[15px] mt-1 leading-tight">
                    {it.name}
                  </div>
                  {it.description && (
                    <div className="text-[#d8cfba] text-[12.5px] mt-2 leading-relaxed">
                      {it.description}
                    </div>
                  )}
                  <div className="text-[#e9d9b0] text-sm mt-2 font-medium">{formatINR(it.price)}</div>
                  <div className="flex items-center gap-3 mt-3">
                    <div className="inline-flex items-center border border-[#2a2724]">
                      <button
                        onClick={() => updateQty(it.slug, it.qty - 1)}
                        className="p-1.5 text-[#e9d9b0] hover:text-[#c9a24a]"
                        aria-label="Decrease"
                      >
                        <Minus size={12} />
                      </button>
                      <span className="px-3 text-[#f4ead5] text-sm min-w-[24px] text-center">
                        {it.qty}
                      </span>
                      <button
                        onClick={() => updateQty(it.slug, it.qty + 1)}
                        className="p-1.5 text-[#e9d9b0] hover:text-[#c9a24a]"
                        aria-label="Increase"
                      >
                        <Plus size={12} />
                      </button>
                    </div>
                    <button
                      onClick={() => removeItem(it.slug)}
                      className="text-[#a9a294] hover:text-[#c9a24a]"
                      aria-label="Remove"
                    >
                      <Trash2 size={14} />
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="absolute bottom-0 left-0 right-0 border-t border-[#1c1c1e] p-6 space-y-4 bg-[#0b0b0c]">
          <div className="flex items-center justify-between">
            <div className="text-[#a9a294] uppercase text-[11px] tracking-[0.3em]">
              Subtotal
            </div>
            <div className="font-serif text-[#f4ead5] text-xl">
              {formatINR(subtotal)}
            </div>
          </div>
          <button
            disabled={items.length === 0}
            className="w-full bg-[#c9a24a] hover:bg-[#b48d38] disabled:opacity-50 disabled:cursor-not-allowed text-[#0b0b0c] py-4 text-[12px] uppercase tracking-[0.25em] font-medium transition-colors"
          >
            Secure Checkout
          </button>
          <div className="text-[10px] text-[#a9a294] text-center tracking-wide">
            GST included · UPI, Cards & COD accepted
          </div>
        </div>
      </aside>
    </>
  );
};

export default CartDrawer;
